import { FC, SVGProps } from 'react';
import config from 'config';
import Link from 'next/link';

import { Box, StackProps, useTheme, VStack } from '@chakra-ui/react';

import { ShoppingCartName } from 'types';

import { Button, Text } from 'ui';

const {
  header: { shopLink }
} = config;

interface CartEmptyViewProps extends StackProps {
  Icon: FC<SVGProps<SVGSVGElement>>;
  type: ShoppingCartName;
  isPageSize?: boolean;
  onClick?: () => void;
}
const CartEmptyView = ({
  Icon,
  type,
  isPageSize = false,
  onClick = () => {},
  ...props
}: CartEmptyViewProps) => {
  const {
    colors: {
      palette: { shop: styles }
    }
  } = useTheme();

  return (
    <VStack w='full' gap='40px' {...props}>
      <Box
        sx={{
          '& > svg': {
            width: { base: '120px', md: isPageSize ? '180px' : '120px' },
            height: { base: '120px', md: isPageSize ? '180px' : '120px' }
          }
        }}
      >
        <Icon fill={styles.icon} />
      </Box>
      <Box w='full' textAlign='center'>
        <Text
          color={styles.heading}
          variant='h1'
          as='h1'
          fontFamily='main'
          fontWeight='semibold'
          fontSize={{
            base: isPageSize ? '22px' : '16px',
            md: isPageSize ? '25px' : '20px',
            lg: isPageSize ? '28px' : '22px'
          }}
          mb='20px'
        >
          Your {type} is Empty
        </Text>
        <Text
          color={styles.description}
          fontSize={{ base: '14px', md: '16px' }}
          lineHeight={{ base: '20px', md: '24px' }}
        >
          It looks like you haven’t added any items to your {type} yet.
        </Text>
        <Text
          color={styles.description}
          fontSize={{ base: '14px', md: '16px' }}
          lineHeight={{ base: '20px', md: '24px' }}
        >
          Continue Shopping to find the perfect products for you.
        </Text>
      </Box>
      <Button onClick={onClick} as={Link} href={shopLink} maxW={272}>
        Proceed to shopping
      </Button>
    </VStack>
  );
};

export default CartEmptyView;
